/*
 * Created Date: Tue, 8th Dec 2020, 16:36:46 pm
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { ActionButton } from 'Components/Buttons';
import { ChevronRight, ChevronLeft } from '@material-ui/icons';
import { actionButtonStyles, centeredStyle } from 'styles';

const ChecklistImageViewer = ({ questions, currentIndex, setCurrentIndex }) => {
  const classes = centeredStyle();
  const buttonClasses = actionButtonStyles(25);

  const showNextImage = () => {
    setCurrentIndex(currentIndex + 1);
  };

  const showPreviousImage = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const totalWidth = 400;
  const margin = 15;
  const contentWidth = totalWidth - margin;
  const imageHeight = totalWidth - margin * 4 - 30;

  const styles = {
    container: {
      width: totalWidth,
      height: totalWidth,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      marginRight: margin,
      marginLeft: margin,
      overflow: 'hidden',
      flex: 0.6,
    },
    image: {
      maxWidth: contentWidth,
      maxHeight: imageHeight,
    },
    buttonsContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      width: contentWidth,
      paddingTop: margin,
      paddingBottom: margin,
    },
    orderText: {
      fontSize: 12,
      paddingTop: margin,
      paddingBottom: margin,
    },
  };

  return (
    <div
      key="checklist-image-container-div"
      className={classes.container}
      style={styles.container}
    >
      <img
        key={questions[currentIndex].id}
        className={classes.image}
        src={questions[currentIndex].image.url}
        alt="checklist"
        style={styles.image}
      />
      <span style={styles.orderText}>
        {`${currentIndex + 1} / ${questions.length}`}
      </span>
      <div
        key="checklist-image-buttons-container"
        className={classes.container}
        style={styles.buttonsContainer}
      >
        <ActionButton
          icon={<ChevronLeft />}
          name=""
          disabled={currentIndex < 1}
          onClick={() => showPreviousImage()}
          className={buttonClasses.checklistImageButton}
        />
        <ActionButton
          icon={<ChevronRight />}
          name=""
          disabled={currentIndex >= questions.length - 1}
          onClick={() => showNextImage()}
          className={buttonClasses.checklistImageButton}
        />
      </div>
    </div>
  );
};

export default ChecklistImageViewer;
